declare global {
  interface NavigatorUAData {
    mobile: boolean;
  }

  interface Navigator {
    userAgentData?: NavigatorUAData;
  }
}

const MOBILE_USER_AGENT_REGEX =
  /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;

export function isMobileDevice() {
  if (typeof navigator === 'undefined') {
    return false;
  }

  if (navigator.userAgentData?.mobile !== undefined) {
    return navigator.userAgentData.mobile;
  }

  const userAgent = navigator.userAgent ?? navigator.vendor ?? '';

  return MOBILE_USER_AGENT_REGEX.test(userAgent);
}
